import Text from 'components/Text/Text';
import React, { useContext, useEffect, useRef } from 'react';
import { IGetDishesShortByRestaurantId } from 'types';
import { Select } from 'antd';
import { useFetchData } from 'hooks/useFetchData';
import SelectDropdownReloader from 'components/SelectDropdownReloader/SelectDropdownReloader';
import { useTranslation } from 'react-i18next';
import {
	ChangePortionPositionContext,
	IChangePortionPositionContext,
} from '../../../../changePortionPositionState/changePortionPositionContext';
import { getDishesShortByRestaurantId } from 'backend/dishes';
import style from './DishSelect.module.scss';

const { Option } = Select;

export const DishSelect: React.FC = () => {
	const { setIDDish, selectedRestaurant, IDSelectedDish } =
		useContext<IChangePortionPositionContext>(ChangePortionPositionContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { response, loading, refetch, responseError } = useFetchData<IGetDishesShortByRestaurantId, string>(
		selectedRestaurant ? getDishesShortByRestaurantId : null,
		selectedRestaurant?.id || '',
	);
	const { t } = useTranslation('listing');

	useEffect(() => {
		refetch();
	}, [selectedRestaurant]);

	return (
		<div className={style.container}>
			<Text translationNameSpace="listing" translationKey="dishLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={setIDDish}
				value={IDSelectedDish}
				loading={loading}
				listItemHeight={response?.data.restaurantDishes.length}
				allowClear={true}
				disabled={!selectedRestaurant || loading}
				notFoundContent={responseError ? <SelectDropdownReloader onReload={refetch} /> : undefined}
				showSearch={true}
				filterOption={(inputValue, option) =>
					option?.children ? String(option.children).toLowerCase().includes(inputValue.toLowerCase()) : false
				}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				placeholder={t('selectPlaceholder')}>
				{response?.data.restaurantDishes.length ? (
					<>
						<Option className={style.disabledItem} value="empty" disabled={true}>
							<Text
								translationNameSpace="listing"
								translationKey="selectAnyItemPlaceholder"
								asFragment={true}
							/>
						</Option>
						{response?.data.restaurantDishes.map((el) => (
							<Option className={style.listItem} value={el.id} key={el.id}>
								{el.name}
							</Option>
						))}
					</>
				) : null}
			</Select>
		</div>
	);
};
